// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * MIRA-4411: share 12px menu corners, 4px insets and 6px option corners.
 * Kendo ComboBox, MultiSelect and DropDownList use k-list-container;
 * custom list menus opt in with mira-dropdown / mira-dropdown-item.
 * Calendar, time picker and tooltip popups are intentionally excluded.
 */
.k-popup.k-list-container,
.mira-dropdown {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 12px !important;
  padding: 4px !important;
}

.k-popup.k-list-container .k-list-item,
.k-popup.k-list-container .k-list-optionlabel,
.mira-dropdown .mira-dropdown-item {
  border-radius: 6px;
}

/* Keep the existing selected/focused colors on Kendo list options. */
.mira-dropdown .mira-dropdown-item:not(:disabled):not([aria-disabled='true']):hover {
  background-color: #f1f0f2;
}
`, "",{"version":3,"sources":["webpack://./src/css/DropdownMenu.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;;EAEE,8BAAsB;UAAtB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA,qEAAqE;AACrE;EACE,yBAAyB;AAC3B","sourcesContent":["/*\n * MIRA-4411: share 12px menu corners, 4px insets and 6px option corners.\n * Kendo ComboBox, MultiSelect and DropDownList use k-list-container;\n * custom list menus opt in with mira-dropdown / mira-dropdown-item.\n * Calendar, time picker and tooltip popups are intentionally excluded.\n */\n.k-popup.k-list-container,\n.mira-dropdown {\n  box-sizing: border-box;\n  border-radius: 12px !important;\n  padding: 4px !important;\n}\n\n.k-popup.k-list-container .k-list-item,\n.k-popup.k-list-container .k-list-optionlabel,\n.mira-dropdown .mira-dropdown-item {\n  border-radius: 6px;\n}\n\n/* Keep the existing selected/focused colors on Kendo list options. */\n.mira-dropdown .mira-dropdown-item:not(:disabled):not([aria-disabled='true']):hover {\n  background-color: #f1f0f2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
